import { useState } from "react";
import CustomSigningOfferModal from "../../components/modal/CustomSigningOfferModal";

const Prices = ({ block }: { block: any }) => {
  const [showCustomSigningOfferModal, setShowCustomSigningOfferModal] =
    useState(false);

  return (
    <section className="prices" id="prices">
      <div className="container">
        <div className="row">
          <div className="col">
            <div className="title">
              <h3 className="fade-in-left">Előfizetéses csomagok</h3>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-6">
            <div className="prices__box word">
              <img
                src="/images/signowise-hu/sw-word.svg"
                alt="Signo Wise"
                className="prices__box--img"
              />
              <div className="price-main">
                <h3>19 900 Ft</h3>
                <span>+ ÁFA/év</span>
              </div>
              <div className="price-list">
                <ul>
                  <li>Díjmentesen kipróbálható valamennyi funkció</li>
                  <li>Microsoft Wordből indítható aláírás</li>
                  <li className="cancel">
                    Saját dokumentumgenerálóból indítható aláírás (API
                    integráció)
                  </li>
                  <li>20 db aláírókredit jogilag is érvényes aláírásokhoz</li>
                  <li>Emailes support</li>
                </ul>
                <a href="https://sjn3bn5pqfaxkdff.public.blob.vercel-storage.com/SignoWiseWordAddin.exe">
                  <button className="btn">
                    Word plugin letöltése{" "}
                    <img
                      src="/images/signowise-hu/arrow-btn.svg"
                      alt="arrow-btn"
                    />
                  </button>
                </a>
              </div>
            </div>
          </div>
          <div className="col-xl-6">
            <div className="prices__box cloud">
              <img
                src="/images/signowise-hu/sw-cloud.svg"
                alt="Signo Wise"
                className="prices__box--img"
              />
              <div className="price-main">
                <h3>299 900 Ft</h3>
                <span>+ ÁFA/év</span>
              </div>
              <div className="price-list">
                <ul>
                  <li>Díjmentesen kipróbálható valamennyi funkció</li>
                  <li>Microsoft Wordből indítható aláírás</li>
                  <li>
                    Saját dokumentumgenerálóból indítható aláírás (API
                    integráció)
                  </li>
                  <li>200 db aláírókredit jogilag is érvényes aláírásokhoz</li>
                  <li>Emailes support</li>
                </ul>
                <button
                  className="btn"
                  onClick={() => setShowCustomSigningOfferModal(true)}
                >
                  Érdeklődöm
                  <img
                    src="/images/signowise-hu/arrow-btn.svg"
                    alt="arrow-btn"
                  />
                </button>
                <CustomSigningOfferModal
                  showModal={showCustomSigningOfferModal}
                  setShowModal={setShowCustomSigningOfferModal}
                  block={block}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Prices;
